/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
"use strict";
var CompileBinding = (function () {
    function CompileBinding(node, sourceAst) {
        this.node = node;
        this.sourceAst = sourceAst;
    }
    return CompileBinding;
}());
exports.CompileBinding = CompileBinding;
//# sourceMappingURL=compile_binding.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/@angular/compiler/src/view_compiler/compile_binding.js
 ** module id = 992
 ** module chunks = 0
 **/